import { unauthorizedAPI } from "@/config/axios.config";
import { UtilsService } from "../utils";

const utils = new UtilsService();

export interface AppConfig {
  isTemplatePublisher: boolean;
  hasTemplateSource: boolean;
}

class AppConfigService {
  async getConfig(): Promise<AppConfig> {
    return utils.handleApiRequest(() => unauthorizedAPI.get("/app-config"));
  }
}

export const appConfigService = new AppConfigService();
